import React from "react";
import "./LoadingIcon.scss";

interface LoadingIconProps {
  color?: string;
  size?: "small" | "medium" | "large";
  showText?: boolean;
  message?: string;
}

export const LoadingIcon: React.FC<LoadingIconProps> = ({
  color = "#3c1283",
  size = "medium",
  showText = true,
  message = "Loading...",
}) => {
  return (
    <div className={`LoadingIcon LoadingIcon--${size}`}>
      <div
        className="LoadingIcon__spinner"
        style={{ borderColor: color, borderBottomColor: "transparent" }}
      />
      {showText && (
        <span className="LoadingIcon__text" style={{ color }}>
          {message}
        </span>
      )}
    </div>
  );
};

export default LoadingIcon;
